import { auth } from 'routes/config';
import { Navigate, Route, Routes } from 'react-router-dom';

import Login from 'pages/Public/Authentication/Login';
import Logout from 'pages/Public/Authentication/Logout';
import EmailVerification from 'pages/Public/Authentication/EmailVerification';
import NetsapiensCallback from 'pages/Public/Authentication/NetsapiensCallback';
import SSO from '@/pages/Public/Authentication/Sso';

export default function AuthRouter() {
  return (
    <Routes>
      <Route path={auth.login} element={<Login />} />
      <Route path={auth.netsapiensCallback} element={<NetsapiensCallback />} />
      <Route path={auth.logout} element={<Logout />} />
      <Route path={auth.emailVerification} element={<EmailVerification />} />
      <Route path={auth.sso} element={<SSO />} />
      <Route path='*' element={<Navigate to='/404' replace />} />
    </Routes>
  );
}
